"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MicCheckButton = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _dialer = require("../../../../icons-react/dialer");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Sizes = _Button["default"].Sizes;
var STATES = {
  DEFAULT: 'default',
  TIP: 'tip',
  CHECKING: 'checking',
  DETECTED: 'detected',
  NOT_DETECTED: 'not_detected'
};
var wait = function wait(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};
var MicCheckButton = exports.MicCheckButton = function MicCheckButton(_ref) {
  var className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? Sizes.TINY : _ref$size;
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    quality = _useState2[0],
    setQuality = _useState2[1];
  var _useState3 = (0, _react.useState)(STATES.DEFAULT),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    status = _useState4[0],
    setStatus = _useState4[1];
  (0, _react.useEffect)(function () {
    if (status !== STATES.CHECKING) return;
    var stream;
    var audioContext;
    var detectSound = /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var analyser, microphone, scriptProcessor, maxQuality;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return navigator.mediaDevices.getUserMedia({
                audio: true
              });
            case 2:
              stream = _context.sent;
              audioContext = new AudioContext();
              analyser = audioContext.createAnalyser();
              microphone = audioContext.createMediaStreamSource(stream);
              scriptProcessor = audioContext.createScriptProcessor();
              microphone.connect(analyser);
              analyser.connect(scriptProcessor);
              scriptProcessor.connect(audioContext.destination);
              maxQuality = 0;
              scriptProcessor.onaudioprocess = function () {
                var array = new Uint8Array(analyser.frequencyBinCount);
                analyser.getByteFrequencyData(array);
                var arraySum = array.reduce(function (a, value) {
                  return a + value;
                }, 0);
                var average = arraySum / array.length;
                maxQuality = Math.max(maxQuality, average);
                setQuality(average);
              };
              _context.next = 14;
              return wait(3000);
            case 14:
              setStatus(maxQuality > 0 ? STATES.DETECTED : STATES.NOT_DETECTED);
              scriptProcessor.disconnect();
              analyser.disconnect();
              microphone.disconnect();
              stream.getTracks().forEach(function (track) {
                return track.stop();
              });
              stream = null;
              audioContext = null;
              _context.next = 23;
              return wait(1000);
            case 23:
              setStatus(STATES.DEFAULT);
            case 24:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function detectSound() {
        return _ref2.apply(this, arguments);
      };
    }();
    detectSound();
  }, [status]);
  var handleClick = (0, _react.useCallback)( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          setStatus(STATES.TIP);
          _context2.next = 3;
          return wait(1000);
        case 3:
          setStatus(STATES.CHECKING);
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })), [setStatus]);
  return /*#__PURE__*/_react["default"].createElement(StyledMicCheckButton, {
    className: className,
    onClick: handleClick,
    size: size,
    offHover: true
  }, /*#__PURE__*/_react["default"].createElement(StyledIcon, null), status === STATES.DEFAULT && 'Проверить', status === STATES.TIP && 'Говорите', status === STATES.CHECKING && /*#__PURE__*/_react["default"].createElement(StyledProgress, null, /*#__PURE__*/_react["default"].createElement(StyledProgressBar, {
    style: {
      width: "".concat(quality, "px")
    }
  })), status === STATES.DETECTED && 'Все ок!', status === STATES.NOT_DETECTED && 'Не слышно!');
};
var StyledMicCheckButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "MicCheckButton__StyledMicCheckButton",
  componentId: "sc-143jxlf-0"
})(["display:flex;position:relative;gap:7px;padding:0 10px;align-items:center;min-width:115px;"]);
var StyledIcon = (0, _styledComponents["default"])(_dialer.Mic).withConfig({
  displayName: "MicCheckButton__StyledIcon",
  componentId: "sc-143jxlf-1"
})(["width:9px;height:16px;> *{stroke:#007aff;}"]);
var StyledProgress = _styledComponents["default"].div.withConfig({
  displayName: "MicCheckButton__StyledProgress",
  componentId: "sc-143jxlf-2"
})(["height:8px;border-radius:6px;flex:1;position:relative;overflow:hidden;border:1px solid #007aff;"]);
var StyledProgressBar = _styledComponents["default"].div.withConfig({
  displayName: "MicCheckButton__StyledProgressBar",
  componentId: "sc-143jxlf-3"
})(["top:0;left:0;height:100%;position:absolute;background:linear-gradient(to right,#a8ff78,#78ffd6);"]);